import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import {
  DeviceItemsEnum,
  DeviceSettingsContent,
  DeviceSettingsVariantEnum,
} from 'entities/DeviceSettings'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CallSection } from 'widgets/CallPopUp/ui/CallSection/CallSection'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import styles from './styles.module.scss'

export const CallMicPopUpContent = observer(() => {
  const { callStore } = useEntitiesContext()
  const store = useCallPopUpDefaultContext()
  const { initMic, resetMic } = store

  useEffect(() => {
    initMic()

    return () => {
      resetMic()
    }
  }, [])

  return (
    <div className={styles.wrapContent}>
      <CallSection title={'Settings'}>
        <DeviceSettingsContent
          deviceSettingsStore={callStore.deviceSettingsStore}
          testOutputDevice={() => {
            callStore.testOutputDevice()
          }}
          variant={DeviceSettingsVariantEnum.container}
          dropdownProps={{
            width: 298,
            margin: -30,
            ariaLabel: 'Settings',
          }}
          exclude={[DeviceItemsEnum.recordAuto]}
        />
      </CallSection>
    </div>
  )
})
